import { render, staticRenderFns } from "./recipients-from.vue?vue&type=template&id=a1c7ce00&"
import script from "./recipients-from.vue?vue&type=script&lang=js&"
export * from "./recipients-from.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports